import { dataDogApplicationId, dataDogClientToken, nodeEnv } from '@/environment';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export const initDataDog = () => {
    // skip RUM during e2e tests
    if (process.env.CI) {
        return;
    }

    datadogRum.init({
        applicationId: dataDogApplicationId,
        clientToken: dataDogClientToken,
        site: 'us3.datadoghq.com',
        service: 'studio',
        env: nodeEnv,

        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        defaultPrivacyLevel: 'mask-user-input',
        plugins: [reactPlugin({ router: false })],
        enableExperimentalFeatures: ['feature_flags'],
    });
};
